<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { contentAttributes } = useMessageContext();

const data = computed(() => contentAttributes.value?.data || {});
</script>

<template>
  <BaseBubble class="px-4 py-3" data-bubble-name="evolution-link">
    <a
      :href="data.url"
      target="_blank"
      rel="noopener noreferrer"
      class="flex flex-col gap-1 no-underline"
    >
      <img
        v-if="data.imgUrl"
        :src="data.imgUrl"
        class="rounded-lg max-h-40 object-cover"
      />
      <p v-if="data.title" class="font-medium mb-0">{{ data.title }}</p>
      <p v-if="data.description" class="mb-0">{{ data.description }}</p>
      <p v-if="data.text" class="mb-0">{{ data.text }}</p>
      <p class="text-xs opacity-70 mb-0 truncate">{{ data.url }}</p>
    </a>
  </BaseBubble>
</template>
